<template>
  <div class="news-list-container">
    <div class="content lg-mx">
      <newsBlock :dataInfo="item" :key="index" v-for="(item, index) in contentList" />
    </div>

    <div class="page text-center">
      <el-pagination
        background
        @current-change="currentPageChange"
        :current-page.sync="page"
        :page-size="pageSize"
        layout="prev, pager, next"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import newsBlock from '@/components/newsBlock'
import { fetchContentList } from '@/api/content'
import { MODULE_CONFIG } from '@/config/index'

import pageMixins from '@/mixins/page'

export default {
  mixins: [pageMixins],
  components: {
    newsBlock
  },

  data() {
    return {
      contentList: [],

      moduleId: MODULE_CONFIG.NEWS,
      secModuleId: ''
    }
  },
  methods: {
    commonFetch(id) {
      this.secModuleId = id
      this.page = 1

      this.getContentList()
    },

    async getContentList() {
      try {
        const { data, total } = await fetchContentList({
          page: this.page,
          pageSize: this.pageSize,
          pid: this.moduleId,
          cate_id: this.secModuleId
        })

        this.contentList = data
        this.total = total
      } catch (error) {

      }
    }

  },
  watch: {
    $route(newVal) {
      const { id } = newVal.params

      this.commonFetch(id)

    }
  },
  created() {
    const { id } = this.$route.params

    this.commonFetch(id)
  }
}
</script>

<style lang="scss">
.news-list-container {

  .content {
    /*padding-top: 44px;*/
    margin-bottom: 62px;
  }
}
</style>
